import AppProjectPage from "../app"
import ProjectPageSettingsManager from "../settings/settings-manager";

export default function page_toggleFullWidth(value: boolean) {
    const app: AppProjectPage = gd.getMainApp() as AppProjectPage
    const settings: ProjectPageSettingsManager = app.settings as ProjectPageSettingsManager

    const newValue       = !_.isNil(value) ? value : !settings.isFullWidth
    const isValueChanged = settings.isFullWidth !== newValue
    settings.isFullWidth = newValue

    if (isValueChanged) {
        app.render()
    }
}